module.exports = __webpack_public_path__ + "img/7.81fc9b56.webp";